module.exports = __webpack_public_path__ + "img/img_icon.cc1cb9a8.svg";